import React from "react";
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import {
  ChevronLeft,
  ChevronRightOutlined,
  HomeOutlined,
  DirectionsCarFilled,
  ReceiptLongOutlined,
  AdminPanelSettingsOutlined,
  Widgets,
  Paid,
  SupportAgent,
  AccountBalance,
  Group,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FlexBetween from "./FlexBetween";

const Sidebar = ({
  user,
  drawerWidth,
  isSidebarOpen,
  setIsSidebarOpen,
  isNonMobile,
}) => {
  const { pathname } = useLocation();
  const [active, setActive] = useState("");
  const navigate = useNavigate();
  const theme = useTheme();
  useEffect(() => {
    setActive(pathname);
  }, [pathname]);

  const navItems = [
    {
      text: "Dashboard",
      icon: <HomeOutlined />,
      route: "/dashboard",
      roles: [
        "Admin",
        "RTO Agent",
        "Sales Manager",
        "Sales Consultant",
        "Workshop Staff",
        "Insurance Agent",
        "Accountant",
      ],
    },
    {
      text: "Inventory",
      icon: null,
      roles: [
        "Admin",
        "RTO Agent",
        "Sales Manager",
        "Sales Consultant",
        "Workshop Staff",
        "Insurance Agent",
        "Accountant",
      ],
      route: "/inventory-overview",
    },
    // {
    //   text: "Overview",
    //   icon: <Widgets />,
    //   route: "/inventory/overview",
    // },
    {
      text: "Cars",
      icon: <DirectionsCarFilled />,
      roles: [
        "Admin",
        "RTO Agent",
        "Sales Manager",
        "Sales Consultant",
        "Workshop Staff",
        "Insurance Agent",
        "Accountant",
      ],
      route: "/inventory-list",
    },
    {
      text: "Sales",
      icon: null,
      roles: ["Admin", "Sales Manager", "Sales Consultant"],
      route: "/sales-overview",
    },
    {
      text: "Overview",
      icon: <Widgets />,
      roles: ["Admin", "Sales Manager", "Sales Consultant"],
      route: "/sales-overview",
    },
    {
      text: "Transactions",
      icon: <ReceiptLongOutlined />,
      roles: ["Admin", "Accountant"],
      route: "/sales-transactions",
    },
    {
      text: "RTO",
      icon: <ReceiptLongOutlined />,
      roles: ["Admin", "RTO Agent"],
      route: "/rto-tab",
    },
    {
      text: "Insurance",
      icon: <ReceiptLongOutlined />,
      roles: ["Admin", "Insurance Agent"],
      route: "/insurance-tab",
    },
    {
      text: "Invoices",
      icon: <Paid />,
      roles: ["Admin", "Accountant"],
      route: "/sales-invoices",
    },
    {
      text: "Enquiries",
      icon: <SupportAgent />,
      roles: ["Admin", "Sales Manager", "Sales Consultant"],
      route: "/enquiry-overview",
    },
    {
      text: "Expenses",
      icon: <AccountBalance />,
      roles: ["Admin", "Accountant", "Workshop Staff"],
      route: "/expenses-overview",
    },
    {
      text: "Management",
      icon: null,
      route: "/management/user",
      roles: ["Admin"],
    },
    {
      text: "Register User",
      icon: <AdminPanelSettingsOutlined />,
      roles: ["Admin"],
      route: "/register",
    },
    {
      text: "Users",
      icon: <Group />,
      roles: ["Admin"],
      route: "/management-list",
    },
    // {
    //   text: "Change Password",
    //   icon: <AdminPanelSettingsOutlined />,
    //   roles: ["Admin"],
    //   route: "/change-password",
    // },
    // {
    //   text: user.role, //to be changed to "Users"
    //   icon: <AdminPanelSettingsOutlined />,
    //   roles: ["Admin"],
    //   route: "/management-overview",
    // },
  ];

  return (
    <Box component="nav">
      {isSidebarOpen && (
        <Drawer
          open={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
          variant="persistent"
          anchor="left"
          sx={{
            width: drawerWidth,
            "& .MuiDrawer-paper": {
              color: "white",
              backgroundColor: theme.palette.secondary[500],
              boxSixing: "border-box",
              borderWidth: isNonMobile ? 0 : "2px",
              width: drawerWidth,
            },
          }}
        >
          <Box width="100%">
            <Box m="1.5rem 2rem 2rem 3rem">
              <FlexBetween color={"white"}>
                <Box display="flex" alignItems="center" gap="0.75rem">
                  <Typography
                    variant="h3"
                    fontWeight="bold"
                    sx={{
                      fontFamily: "'Michroma', 'sans-serif'",
                      textAlign: "center",
                    }}
                  >
                  </Typography>
                </Box>
                {!isNonMobile && (
                  <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                    <ChevronLeft />
                  </IconButton>
                )}
              </FlexBetween>
            </Box>
            <List>
              {navItems.map(({ text, icon, route, roles }) => {
                const rolesList =
                  roles?.filter((role) => role === user.role) || [];

                if (!icon && rolesList.length > 0) {
                  return (
                    <Typography key={text} sx={{ m: "2.25rem 0 1rem 3rem" }}>
                      {text}
                    </Typography>
                  );
                }
                const routeText = route;
                const lcText = text.toLowerCase();

                return (
                  rolesList.length > 0 && (
                    <ListItem key={text} disablePadding>
                      <ListItemButton
                        onClick={() => {
                          navigate(routeText);
                          setActive(routeText);
                        }}
                        sx={{
                          backgroundColor:
                            active === routeText ? "#114AAA" : "transparent",
                          color: active === routeText ? "white" : "white",
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            ml: "2rem",
                            color: active === routeText ? "white" : "white",
                          }}
                        >
                          {icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={text}
                          primaryTypographyProps={{
                            fontSize: "0.85rem",
                            fontWeight: "bold",
                          }}
                        />
                        {active === lcText && (
                          <ChevronRightOutlined sx={{ ml: "auto" }} />
                        )}
                      </ListItemButton>
                    </ListItem>
                  )
                );
              })}
            </List>
          </Box>

          <Box bottom="2rem">
            <Divider />
          </Box>
        </Drawer>
      )}
    </Box>
  );
};

export default Sidebar;
